import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Vue.js stock trader project</h1>
			<p className='project-popup__description '>
				That’s a final task in the Udemy’s complete Vue.js course. It covers almost
				all features from Vue.js documentation. The app's purpose is to make more
				money and not become bankrupt.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>Vue.js, vuex, vue-router</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<p className='image-description '>Here user can buy stocks</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/vue-stock/main.webp',
						backupImage: './media/projects/vue-stock/main.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='vue-stock-game1' />}
				</ProgressiveImage>
				<p className='image-description '>Here user can sell his stocks</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/vue-stock/1.webp',
						backupImage: './media/projects/vue-stock/1.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img src={src} alt='vue-stock-game2' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://slava-nik.github.io/Vue.js-Course-task'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
